// apiClient.js
import axios from 'axios';

// export const baseurl = 'https://salesroutephase2.technaureus.com/'; 
// export const baseurl = 'http://127.0.0.1:8000/';
export const baseurl = 'https://salesroute.ai/';

// const apiClient = axios.create({
//   baseURL: baseurl,
//   timeout: 10000,
// });

// let isRefreshing = false;
// let refreshSubscribers = [];

// const subscribeTokenRefresh = (callback) => refreshSubscribers.push(callback);
// const onTokenRefreshed = (token) => {
//   refreshSubscribers.forEach(callback => callback(token));
//   refreshSubscribers = [];
// };

// const isTokenExpired = (token) => {
//   if (!token) return true;
//   try {
//     const { exp } = JSON.parse(atob(token.split('.')[1]));
//     return Date.now() >= exp * 1000;
//   } catch {
//     return true;
//   }
// };

// const refreshAuthToken = async () => {
//   const refreshToken = localStorage.getItem('refreshToken');
//   if (!refreshToken) return null;

//   try {
//     const { data } = await axios.post(`${baseurl}accounts/token/refresh/`, { refresh: refreshToken });
//     localStorage.setItem('accessToken', data.access);
//     if (data.refresh) localStorage.setItem('refreshToken', data.refresh);
//     return data.access;
//   } catch (error) {
//     if (error.response?.status === 401) {
//       localStorage.clear();
//       window.location.href = '/login';
//     }
//     return null;
//   }
// };

// apiClient.interceptors.request.use(async (config) => {
//   let token = localStorage.getItem('accessToken');
//   if (token && isTokenExpired(token)) token = await refreshAuthToken();
//   if (token) config.headers['Authorization'] = `Bearer ${token}`;
//   return config;
// }, Promise.reject);

// apiClient.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;
//     if (error.response?.status === 401 && !originalRequest._retry) {
//       if (isRefreshing) {
//         return new Promise(resolve => {
//           subscribeTokenRefresh(token => {
//             originalRequest.headers['Authorization'] = `Bearer ${token}`;
//             resolve(apiClient(originalRequest));
//           });
//         });
//       }

//       originalRequest._retry = true;
//       isRefreshing = true;

//       try {
//         const newToken = await refreshAuthToken();
//         isRefreshing = false;
//         if (newToken) {
//           onTokenRefreshed(newToken);
//           originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
//           return apiClient(originalRequest);
//         }
//       } catch {
//         isRefreshing = false;
//         throw error;
//       }
//     }

//     return Promise.reject(error);
//   }
// );

// export default apiClient;



// export const baseurl = 'https://salesroutephase2.technaureus.com/'; 
//export const baseurl = 'http://127.0.0.1:8000/';
// export const baseurl = "https://salesroute.ai/";

export const AUTH_ENDPOINTS = [
    'accounts/login/internal/',
    'accounts/auth/mfa/totp-verify/',
    'accounts/auth/mfa/recovery-verify/',
    'accounts/auth/mfa/enroll-init/',
    'accounts/auth/mfa/enroll-activate/',
    'accounts/token/refresh/',
];

export const isAuthEndpoint = (url) => {
    if (!url) return false;
    const cleanUrl = url.replace(baseurl, '').replace(/^\/+/, '').split('?')[0];
    return AUTH_ENDPOINTS.includes(cleanUrl);
};

const apiClient = axios.create({
    baseURL: baseurl,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    }
});

// Add a request interceptor to include token (excluding authentication endpoints)
apiClient.interceptors.request.use(
    async (config) => {
        if (!isAuthEndpoint(config.url)) {
            const token = localStorage.getItem('accessToken');
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

let isRefreshing = false;
let refreshSubscribers = [];

const subscribeTokenRefresh = (callback) => {
    refreshSubscribers.push(callback);
};

const onTokenRefreshed = (newAccessToken) => {
    refreshSubscribers.forEach((callback) => callback(newAccessToken));
    refreshSubscribers = [];
};

const onRefreshFailed = (error) => {
    refreshSubscribers.forEach((callback) => callback(null, error));
    refreshSubscribers = [];
};

// Add a response interceptor to handle token refresh
apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        // If no response or originalRequest, reject immediately
        if (!error.response || !originalRequest) {
            return Promise.reject(error);
        }

        // Do not attempt token refresh for authentication/challenge endpoints
        if (isAuthEndpoint(originalRequest.url)) {
            return Promise.reject(error);
        }

        // Handle 401 Unauthorized for authenticated requests
        if (error.response.status === 401 && !originalRequest._retry) {
            const refreshToken = localStorage.getItem('refreshToken');

            // Do not attempt refresh if no usable refresh token exists
            if (!refreshToken) {
                if (window.location.pathname !== '/login') {
                    localStorage.removeItem('accessToken');
                    localStorage.removeItem('refreshToken');
                    localStorage.removeItem('authToken');
                    window.location.href = '/login';
                }
                return Promise.reject(error);
            }

            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    subscribeTokenRefresh((newToken, refreshErr) => {
                        if (refreshErr) {
                            return reject(refreshErr);
                        }
                        originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
                        resolve(apiClient(originalRequest));
                    });
                });
            }

            originalRequest._retry = true;
            isRefreshing = true;

            try {
                const response = await axios.post(`${baseurl}accounts/token/refresh/`, {
                    refresh: refreshToken,
                });

                const { access } = response.data;
                localStorage.setItem('accessToken', access);
                if (response.data.refresh) {
                    localStorage.setItem('refreshToken', response.data.refresh);
                }

                isRefreshing = false;
                onTokenRefreshed(access);

                originalRequest.headers['Authorization'] = `Bearer ${access}`;
                return apiClient(originalRequest);
            } catch (refreshError) {
                isRefreshing = false;
                onRefreshFailed(refreshError);

                localStorage.removeItem('accessToken');
                localStorage.removeItem('refreshToken');
                localStorage.removeItem('authToken');
                localStorage.removeItem('lastVisitedRoute');

                if (window.location.pathname !== '/login') {
                    window.location.href = '/login';
                }
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

/**
 * Retrieve Platform SuperAdmin MFA enrollment and device status.
 * Requires an authenticated session (Bearer token automatically attached by apiClient).
 *
 * @returns {Promise<{
 *   is_enrolled: boolean,
 *   has_active_device: boolean,
 *   enrolled_at: string | null,
 *   last_used_at: string | null,
 *   remaining_recovery_codes: number
 * }>}
 */
export const getMfaStatus = async () => {
    const response = await apiClient.get('accounts/auth/mfa/status/');
    return response.data;
};

/**
 * Initialize MFA device replacement for an authenticated Platform SuperAdmin.
 * Requires current_password for re-authentication.
 *
 * @param {string} currentPassword
 * @returns {Promise<{
 *   secret: string,
 *   provisioning_uri: string,
 *   replacement_token: string,
 *   expires_in: number,
 *   detail: string
 * }>}
 */
export const initMfaDeviceReplace = async (currentPassword) => {
    const response = await apiClient.post('accounts/auth/mfa/device-replace/init/', {
        current_password: currentPassword,
    });
    return response.data;
};

/**
 * Confirm MFA device replacement using candidate replacement_token and TOTP code.
 *
 * @param {string} replacementToken
 * @param {string} totpCode
 * @returns {Promise<{
 *   detail: string,
 *   recovery_codes: string[]
 * }>}
 */
export const confirmMfaDeviceReplace = async (replacementToken, totpCode) => {
    const response = await apiClient.post('accounts/auth/mfa/device-replace/confirm/', {
        replacement_token: replacementToken,
        totp_code: totpCode,
    });
    return response.data;
};

/**
 * Regenerate emergency single-use recovery codes for an authenticated Platform SuperAdmin.
 * Requires current_password and fresh totp_code from active authenticator.
 * Does not permit automatic retry on failure (_retry: true).
 *
 * @param {string} currentPassword
 * @param {string} totpCode
 * @returns {Promise<{
 *   detail: string,
 *   recovery_codes: string[],
 *   count: number
 * }>}
 */
export const regenerateRecoveryCodes = async (currentPassword, totpCode) => {
    const response = await apiClient.post(
        'accounts/auth/mfa/recovery-codes/regenerate/',
        {
            current_password: currentPassword,
            totp_code: totpCode,
        },
        {
            _retry: true,
        }
    );
    return response.data;
};

export default apiClient;


